import React from 'react'

const form = () => {
  return (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title">New Product</h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            Add Atrribute{' '}
          </button>
          <button
            type="button"
            className="btn btn-primary btn-fw rounded"
          >
            {' '}
            Save{' '}
          </button>
        </div>
      </div>
      <div
        className="alert alert-warning alert-dismissible fade show"
        role="alert"
      >
        It&apos;s time to{' '}
        <strong>
          <u>change your password</u>
        </strong>
        <button
          type="button"
          className="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div className="row">
        <div className="col-sm-12 stretch-card grid-margin">
          <div className="card border">
            <div className="card-body p-5">
              <form>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-3 col-form-label"
                      >
                        Enable Product
                      </label>
                      <div className="col-sm-9">
                        <div className="custom-control custom-switch pt-2">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="EnableProduct"
                            checked
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="EnableProduct"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6"></div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-3 col-form-label"
                      >
                        Attribute Set
                      </label>
                      <div className="col-sm-9">
                        <select
                          className="form-control"
                          id=""
                        >
                          <option>Select Attribute</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-3 col-form-label"
                      >
                        Categories
                      </label>
                      <div className="col-sm-9">
                        <select
                          className="form-control"
                          id=""
                        >
                          <option>Select Categories</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-3 col-form-label"
                      >
                        Product Name
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          id=""
                          placeholder=" "
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-3 col-form-label"
                      >
                        SKU
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          id=""
                          placeholder=" "
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-3 col-form-label"
                      >
                        Metal
                      </label>
                      <div className="col-sm-9">
                        <select
                          className="form-control"
                          id=""
                        >
                          <option>14K Rose Gold</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-3 col-form-label"
                      >
                        Stone Clarity
                      </label>
                      <div className="col-sm-9">
                        <select
                          className="form-control"
                          id=""
                        >
                          <option>High</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-3 col-form-label"
                      >
                        Carat
                      </label>
                      <div className="col-sm-9">
                        <select
                          className="form-control"
                          id=""
                        >
                          <option>0.5 MM</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-3 col-form-label"
                      >
                        Ring Size
                      </label>
                      <div className="col-sm-9">
                        <select
                          className="form-control"
                          id=""
                        >
                          <option>Select Ring Size</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-3 col-form-label"
                      >
                        Price
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          id=""
                          placeholder=" "
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-3 col-form-label"
                      >
                        Weight
                      </label>
                      <div className="col-sm-9">
                        <select
                          className="form-control"
                          id=""
                        >
                          <option> </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-3 col-form-label"
                      >
                        Quality
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          id=""
                          placeholder=" "
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-3 col-form-label"
                      >
                        Price
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          id=""
                          placeholder=" "
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-3 col-form-label"
                      >
                        Trending
                      </label>
                      <div className="col-sm-9">
                        <div className="custom-control custom-switch pt-2">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customTrending"
                            checked
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customTrending"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-3 col-form-label"
                      >
                        Best Sellers
                      </label>
                      <div className="col-sm-9">
                        <div className="custom-control custom-switch pt-2">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customBSellers"
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customBSellers"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-3 col-form-label"
                      >
                        Ready to ship
                      </label>
                      <div className="col-sm-9">
                        <select className="form-control">
                          <option> </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-3 col-form-label"
                      >
                        Free Shipping
                      </label>
                      <div className="col-sm-4">
                        <div className="form-check mt-3">
                          <label className="form-check-label">
                            <input
                              type="radio"
                              className="form-check-input"
                              name="freeshippingRadios"
                              id="freeshippingRadios1"
                              value=""
                              checked
                            />{' '}
                            Yes{' '}
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-5">
                        <div className="form-check mt-3">
                          <label className="form-check-label">
                            <input
                              type="radio"
                              className="form-check-input"
                              name="freeshippingRadios"
                              id="freeshippingRadios2"
                              value="option2"
                            />{' '}
                            No{' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row grid-margin">
                  <div className="col-md-12">
                    <div id="accordion">
                      <div className="card shadow-none">
                        <div
                          className="card-header"
                          id="headingOne"
                        >
                          <h5 className="mb-0">
                            <a
                              className="text-dark d-flex justify-content-between font-14"
                              data-toggle="collapse"
                              data-target="#collapseOne"
                              aria-expanded="true"
                              aria-controls="collapseOne"
                            >
                              Content <i className="mdi mdi-chevron-up"></i>
                            </a>
                          </h5>
                        </div>

                        <div
                          id="collapseOne"
                          className="collapse show"
                          aria-labelledby="headingOne"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            <p>
                              {' '}
                              Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus
                              terry richardson ad squid. 3 wolf moon officia aute, non cupidatat
                              skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
                              Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid
                              single-origin coffee nulla assumenda shoreditch et. Nihil anim
                              keffiyeh helvetica, craft beer labore wes anderson cred nesciunt
                              sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings
                              occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt
                              you probably haven&apos;t heard of them accusamus labore sustainable
                              VHS.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card shadow-none">
                        <div
                          className="card-header"
                          id="headingTwo"
                        >
                          <h5 className="mb-0">
                            <a
                              className="text-dark d-flex justify-content-between font-14 collapsed"
                              data-toggle="collapse"
                              data-target="#collapseTwo"
                              aria-expanded="false"
                              aria-controls="collapseTwo"
                            >
                              Configuration <i className="mdi mdi-chevron-up"></i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapseTwo"
                          className="collapse"
                          aria-labelledby="headingTwo"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            <p>
                              {' '}
                              Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus
                              terry richardson ad squid. 3 wolf moon officia aute, non cupidatat
                              skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
                              Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid
                              single-origin coffee nulla assumenda shoreditch et. Nihil anim
                              keffiyeh helvetica, craft beer labore wes anderson cred nesciunt
                              sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings
                              occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt
                              you probably haven&apos;t heard of them accusamus labore sustainable
                              VHS.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card shadow-none">
                        <div
                          className="card-header"
                          id="headingThree"
                        >
                          <h5 className="mb-0">
                            <a
                              className="text-dark d-flex justify-content-between font-14 collapsed"
                              data-toggle="collapse"
                              data-target="#collapseThree"
                              aria-expanded="false"
                              aria-controls="collapseThree"
                            >
                              Attributes <i className="mdi mdi-chevron-up"></i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapseThree"
                          className="collapse"
                          aria-labelledby="headingThree"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            <p>
                              {' '}
                              Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus
                              terry richardson ad squid. 3 wolf moon officia aute, non cupidatat
                              skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
                              Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid
                              single-origin coffee nulla assumenda shoreditch et. Nihil anim
                              keffiyeh helvetica, craft beer labore wes anderson cred nesciunt
                              sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings
                              occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt
                              you probably haven&apos;t heard of them accusamus labore sustainable
                              VHS.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card shadow-none">
                        <div
                          className="card-header"
                          id="headingFour"
                        >
                          <h5 className="mb-0">
                            <a
                              className="text-dark d-flex justify-content-between font-14 collapsed"
                              data-toggle="collapse"
                              data-target="#collapseFour"
                              aria-expanded="false"
                              aria-controls="collapseFour"
                            >
                              Images and Videos <i className="mdi mdi-chevron-up"></i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapseFour"
                          className="collapse"
                          aria-labelledby="headingFour"
                          data-parent="#accordion"
                        >
                          <div className="card-body"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-3 col-form-label"
                      >
                        Enable Product
                      </label>
                      <div className="col-sm-9">
                        <div className="custom-control custom-switch pt-2">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="EnableProduct"
                            checked
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="EnableProduct"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6"></div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-5 col-form-label"
                      >
                        Attribute Set
                      </label>
                      <div className="col-sm-7">
                        <select
                          className="form-control"
                          id=""
                        >
                          <option>Select Attribute</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-5 col-form-label"
                      >
                        Categories
                      </label>
                      <div className="col-sm-7">
                        <select
                          className="form-control"
                          id=""
                        >
                          <option>Select Categories</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-5 col-form-label"
                      >
                        Product Name
                      </label>
                      <div className="col-sm-7">
                        <input
                          type="text"
                          className="form-control"
                          id=""
                          placeholder=" "
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-5 col-form-label"
                      >
                        SKU
                      </label>
                      <div className="col-sm-7">
                        <input
                          type="text"
                          className="form-control"
                          id=""
                          placeholder=" "
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-5 col-form-label"
                      >
                        Metal
                      </label>
                      <div className="col-sm-7">
                        <select
                          className="form-control"
                          id=""
                        >
                          <option>14K Rose Gold</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-5 col-form-label"
                      >
                        Stone Clarity
                      </label>
                      <div className="col-sm-7">
                        <select
                          className="form-control"
                          id=""
                        >
                          <option>High</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-5 col-form-label"
                      >
                        Carat
                      </label>
                      <div className="col-sm-7">
                        <select
                          className="form-control"
                          id=""
                        >
                          <option>0.5 MM</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-5 col-form-label"
                      >
                        Ring Size
                      </label>
                      <div className="col-sm-7">
                        <select
                          className="form-control"
                          id=""
                        >
                          <option>Select Ring Size</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-5 col-form-label"
                      >
                        Price
                      </label>
                      <div className="col-sm-7">
                        <input
                          type="text"
                          className="form-control"
                          id=""
                          placeholder=" "
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-5 col-form-label"
                      >
                        Weight
                      </label>
                      <div className="col-sm-7">
                        <select
                          className="form-control"
                          id=""
                        >
                          <option> </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-5 col-form-label"
                      >
                        Quality
                      </label>
                      <div className="col-sm-7">
                        <input
                          type="text"
                          className="form-control"
                          id=""
                          placeholder=" "
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-5 col-form-label"
                      >
                        Price
                      </label>
                      <div className="col-sm-7">
                        <input
                          type="text"
                          className="form-control"
                          id=""
                          placeholder=" "
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-5 col-form-label"
                      >
                        Trending
                      </label>
                      <div className="col-sm-7">
                        <div className="custom-control custom-switch pt-2">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customTrending"
                            checked
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customTrending"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-5 col-form-label"
                      >
                        Best Sellers
                      </label>
                      <div className="col-sm-7">
                        <div className="custom-control custom-switch pt-2">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customBSellers"
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customBSellers"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-5 col-form-label"
                      >
                        Ready to ship
                      </label>
                      <div className="col-sm-7">
                        <select className="form-control">
                          <option> </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-5 col-form-label"
                      >
                        Free Shipping
                      </label>
                      <div className="col-sm-3">
                        <div className="form-check mt-3">
                          <label className="form-check-label">
                            <input
                              type="radio"
                              className="form-check-input"
                              name="freeshippingRadios"
                              id="freeshippingRadios1"
                              value=""
                              checked
                            />{' '}
                            Yes{' '}
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div className="form-check mt-3">
                          <label className="form-check-label">
                            <input
                              type="radio"
                              className="form-check-input"
                              name="freeshippingRadios"
                              id="freeshippingRadios2"
                              value="option2"
                            />{' '}
                            No{' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-5 col-form-label"
                      >
                        Quality
                      </label>
                      <div className="col-sm-7">
                        <input
                          type="text"
                          className="form-control"
                          id=""
                          placeholder=" "
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label
                        htmlFor=""
                        className="col-sm-5 col-form-label"
                      >
                        Quality
                      </label>
                      <div className="col-sm-7">
                        <input
                          type="text"
                          className="form-control"
                          id=""
                          placeholder=" "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Default form</h4>
              <p className="card-description">Basic form layout</p>
              <form className="forms-sample">
                <div className="form-group">
                  <label htmlFor="exampleInputUsername1">Username</label>
                  <input
                    type="text"
                    className="form-control"
                    id="exampleInputUsername1"
                    placeholder="Username"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Email address</label>
                  <input
                    type="email"
                    className="form-control"
                    id="exampleInputEmail1"
                    placeholder="Email"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputPassword1">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="exampleInputPassword1"
                    placeholder="Password"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputConfirmPassword1">Confirm Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="exampleInputConfirmPassword1"
                    placeholder="Password"
                  />
                </div>
                <div className="form-check form-check-flat form-check-primary">
                  <label className="form-check-label">
                    <input
                      type="checkbox"
                      className="form-check-input"
                    />{' '}
                    Remember me{' '}
                  </label>
                </div>
                <button
                  type="submit"
                  className="btn btn-primary mr-2"
                >
                  {' '}
                  Submit{' '}
                </button>
                <button className="btn btn-light">Cancel</button>
              </form>
            </div>
          </div>
        </div>
        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Horizontal Form</h4>
              <p className="card-description">Horizontal form layout</p>
              <form className="forms-sample">
                <div className="form-group row">
                  <label
                    htmlFor="exampleInputUsername2"
                    className="col-sm-3 col-form-label"
                  >
                    Email
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputUsername2"
                      placeholder="Username"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="exampleInputEmail2"
                    className="col-sm-3 col-form-label"
                  >
                    Email
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="email"
                      className="form-control"
                      id="exampleInputEmail2"
                      placeholder="Email"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="exampleInputMobile"
                    className="col-sm-3 col-form-label"
                  >
                    Mobile
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputMobile"
                      placeholder="Mobile number"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="exampleInputPassword2"
                    className="col-sm-3 col-form-label"
                  >
                    Password
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="password"
                      className="form-control"
                      id="exampleInputPassword2"
                      placeholder="Password"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="exampleInputConfirmPassword2"
                    className="col-sm-3 col-form-label"
                  >
                    Re Password
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="password"
                      className="form-control"
                      id="exampleInputConfirmPassword2"
                      placeholder="Password"
                    />
                  </div>
                </div>
                <div className="form-check form-check-flat form-check-primary">
                  <label className="form-check-label">
                    <input
                      type="checkbox"
                      className="form-check-input"
                    />{' '}
                    Remember me{' '}
                  </label>
                </div>
                <button
                  type="submit"
                  className="btn btn-primary mr-2"
                >
                  {' '}
                  Submit{' '}
                </button>
                <button className="btn btn-light">Cancel</button>
              </form>
            </div>
          </div>
        </div>
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Basic form elements</h4>
              <p className="card-description">Basic form elements</p>
              <form className="forms-sample">
                <div className="form-group">
                  <label htmlFor="exampleInputName1">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="exampleInputName1"
                    placeholder="Name"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail3">Email address</label>
                  <input
                    type="email"
                    className="form-control"
                    id="exampleInputEmail3"
                    placeholder="Email"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputPassword4">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="exampleInputPassword4"
                    placeholder="Password"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleSelectGender">Gender</label>
                  <select
                    className="form-control"
                    id="exampleSelectGender"
                  >
                    <option>Male</option>
                    <option>Female</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>File upload</label>
                  <input
                    type="file"
                    name="img[]"
                    className="file-upload-default"
                  />
                  <div className="input-group col-xs-12">
                    <input
                      type="text"
                      className="form-control file-upload-info"
                      disabled
                      placeholder="Upload Image"
                    />
                    <span className="input-group-append">
                      <button
                        className="file-upload-browse btn btn-primary"
                        type="button"
                      >
                        {' '}
                        Upload{' '}
                      </button>
                    </span>
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputCity1">City</label>
                  <input
                    type="text"
                    className="form-control"
                    id="exampleInputCity1"
                    placeholder="Location"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleTextarea1">Textarea</label>
                  <textarea
                    className="form-control"
                    id="exampleTextarea1"
                    rows="4"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="btn btn-primary mr-2"
                >
                  {' '}
                  Submit{' '}
                </button>
                <button className="btn btn-light">Cancel</button>
              </form>
            </div>
          </div>
        </div>
        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Input size</h4>
              <p className="card-description">
                {' '}
                Add classes like <code>.form-control-lg</code> and <code>.form-control-sm</code>.{' '}
              </p>
              <div className="form-group">
                <label>Large input</label>
                <input
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="Username"
                  aria-label="Username"
                />
              </div>
              <div className="form-group">
                <label>Default input</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Username"
                  aria-label="Username"
                />
              </div>
              <div className="form-group">
                <label>Small input</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Username"
                  aria-label="Username"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Select size</h4>
              <p className="card-description">
                {' '}
                Add classes like <code>.form-control-lg</code> and <code>.form-control-sm</code>.{' '}
              </p>
              <div className="form-group">
                <label htmlFor="exampleFormControlSelect1">Large select</label>
                <select
                  className="form-control form-control-lg"
                  id="exampleFormControlSelect1"
                >
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="exampleFormControlSelect2">Default select</label>
                <select
                  className="form-control"
                  id="exampleFormControlSelect2"
                >
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="exampleFormControlSelect3">Small select</label>
                <select
                  className="form-control form-control-sm"
                  id="exampleFormControlSelect3"
                >
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Basic input groups</h4>
              <p className="card-description">Basic bootstrap input groups</p>
              <div className="form-group">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">@</span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Username"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text bg-primary text-white">$</span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Amount (to the nearest dollar)"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">.00</span>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">$</span>
                  </div>
                  <div className="input-group-prepend">
                    <span className="input-group-text">0.00</span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Amount (to the nearest dollar)"
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Recipient's username"
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-sm btn-primary"
                      type="button"
                    >
                      {' '}
                      Search{' '}
                    </button>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <button
                      className="btn btn-sm btn-outline-primary dropdown-toggle"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {' '}
                      Dropdown{' '}
                    </button>
                    <div className="dropdown-menu">
                      <a
                        className="dropdown-item"
                        href="#"
                      >
                        Action
                      </a>
                      <a
                        className="dropdown-item"
                        href="#"
                      >
                        Another action
                      </a>
                      <a
                        className="dropdown-item"
                        href="#"
                      >
                        Something else here
                      </a>
                      <div
                        role="separator"
                        className="dropdown-divider"
                      ></div>
                      <a
                        className="dropdown-item"
                        href="#"
                      >
                        Separated link
                      </a>
                    </div>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Text input with dropdown button"
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Find in facebook"
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-sm btn-facebook"
                      type="button"
                    >
                      <i className="mdi mdi-facebook"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Checkbox Controls</h4>
              <p className="card-description">
                {' '}
                Checkbox and radio controls (default appearance is in primary color){' '}
              </p>
              <form>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <div className="form-check">
                        <label className="form-check-label">
                          <input
                            type="checkbox"
                            className="form-check-input"
                          />{' '}
                          Default{' '}
                        </label>
                      </div>
                      <div className="form-check">
                        <label className="form-check-label">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked
                          />{' '}
                          Checked{' '}
                        </label>
                      </div>
                      <div className="form-check">
                        <label className="form-check-label">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            disabled
                          />{' '}
                          Disabled{' '}
                        </label>
                      </div>
                      <div className="form-check">
                        <label className="form-check-label">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            disabled
                            checked
                          />{' '}
                          Disabled checked{' '}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <div className="form-check">
                        <label className="form-check-label">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="optionsRadios"
                            id="optionsRadios1"
                            value=""
                          />{' '}
                          Default{' '}
                        </label>
                      </div>
                      <div className="form-check">
                        <label className="form-check-label">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="optionsRadios"
                            id="optionsRadios2"
                            value="option2"
                            checked
                          />{' '}
                          Selected{' '}
                        </label>
                      </div>
                      <div className="form-check">
                        <label className="form-check-label">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="optionsRadios2"
                            id="optionsRadios3"
                            value="option3"
                            disabled
                          />{' '}
                          Disabled{' '}
                        </label>
                      </div>
                      <div className="form-check">
                        <label className="form-check-label">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="optionsRadio2"
                            id="optionsRadios4"
                            value="option4"
                            disabled
                            checked
                          />{' '}
                          Selected and disabled{' '}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="card-body">
              <p className="card-description">
                {' '}
                Add className <code>.form-check</code> htmlFor checkbox and radio controls in theme
                colors{' '}
              </p>
              <form>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <div className="form-check form-check-primary">
                        <label className="form-check-label">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked
                          />{' '}
                          Primary{' '}
                        </label>
                      </div>
                      <div className="form-check form-check-success">
                        <label className="form-check-label">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked
                          />{' '}
                          Success{' '}
                        </label>
                      </div>
                      <div className="form-check form-check-info">
                        <label className="form-check-label">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked
                          />{' '}
                          Info{' '}
                        </label>
                      </div>
                      <div className="form-check form-check-danger">
                        <label className="form-check-label">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked
                          />{' '}
                          Danger{' '}
                        </label>
                      </div>
                      <div className="form-check form-check-warning">
                        <label className="form-check-label">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked
                          />{' '}
                          Warning{' '}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <div className="form-check form-check-primary">
                        <label className="form-check-label">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="ExampleRadio1"
                            id="ExampleRadio1"
                            checked
                          />{' '}
                          Primary{' '}
                        </label>
                      </div>
                      <div className="form-check form-check-success">
                        <label className="form-check-label">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="ExampleRadio2"
                            id="ExampleRadio2"
                            checked
                          />{' '}
                          Success{' '}
                        </label>
                      </div>
                      <div className="form-check form-check-info">
                        <label className="form-check-label">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="ExampleRadio3"
                            id="ExampleRadio3"
                            checked
                          />{' '}
                          Info{' '}
                        </label>
                      </div>
                      <div className="form-check form-check-danger">
                        <label className="form-check-label">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="ExampleRadio4"
                            id="ExampleRadio4"
                            checked
                          />{' '}
                          Danger{' '}
                        </label>
                      </div>
                      <div className="form-check form-check-warning">
                        <label className="form-check-label">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="ExampleRadio5"
                            id="ExampleRadio5"
                            checked
                          />{' '}
                          Warning{' '}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Inline forms</h4>
              <p className="card-description">
                {' '}
                Use the <code>.form-inline</code> className to display a series of labels, form
                controls, and buttons on a single horizontal row{' '}
              </p>
              <form className="form-inline">
                <label
                  className="sr-only"
                  htmlFor="inlineFormInputName2"
                >
                  Name
                </label>
                <input
                  type="text"
                  className="form-control mb-2 mr-sm-2"
                  id="inlineFormInputName2"
                  placeholder="Jane Doe"
                />
                <label
                  className="sr-only"
                  htmlFor="inlineFormInputGroupUsername2"
                >
                  Username
                </label>
                <div className="input-group mb-2 mr-sm-2">
                  <div className="input-group-prepend">
                    <div className="input-group-text">@</div>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    id="inlineFormInputGroupUsername2"
                    placeholder="Username"
                  />
                </div>
                <div className="form-check mx-sm-2">
                  <label className="form-check-label">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked
                    />{' '}
                    Remember me{' '}
                  </label>
                </div>
                <button
                  type="submit"
                  className="btn btn-primary mb-2"
                >
                  {' '}
                  Submit{' '}
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Horizontal Two column</h4>
              <form className="form-sample">
                <p className="card-description">Personal info</p>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">First Name</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Last Name</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Gender</label>
                      <div className="col-sm-9">
                        <select className="form-control">
                          <option>Male</option>
                          <option>Female</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Date of Birth</label>
                      <div className="col-sm-9">
                        <input
                          className="form-control"
                          placeholder="dd/mm/yyyy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Category</label>
                      <div className="col-sm-9">
                        <select className="form-control">
                          <option>Category1</option>
                          <option>Category2</option>
                          <option>Category3</option>
                          <option>Category4</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Membership</label>
                      <div className="col-sm-4">
                        <div className="form-check">
                          <label className="form-check-label">
                            <input
                              type="radio"
                              className="form-check-input"
                              name="membershipRadios"
                              id="membershipRadios1"
                              value=""
                              checked
                            />{' '}
                            Free{' '}
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-5">
                        <div className="form-check">
                          <label className="form-check-label">
                            <input
                              type="radio"
                              className="form-check-input"
                              name="membershipRadios"
                              id="membershipRadios2"
                              value="option2"
                            />{' '}
                            Professional{' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="card-description">Address</p>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Address 1</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">State</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Address 2</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Postcode</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">City</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Country</label>
                      <div className="col-sm-9">
                        <select className="form-control">
                          <option>America</option>
                          <option>Italy</option>
                          <option>Russia</option>
                          <option>Britain</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Select 2</h4>
              <div className="form-group">
                <label>Single select box using select 2</label>
                <select className="js-example-basic-single w-100">
                  <option value="AL">Alabama</option>
                  <option value="WY">Wyoming</option>
                  <option value="AM">America</option>
                  <option value="CA">Canada</option>
                  <option value="RU">Russia</option>
                </select>
              </div>
              <div className="form-group">
                <label>Multiple select using select 2</label>
                <select
                  className="js-example-basic-multiple w-100"
                  multiple="multiple"
                >
                  <option value="AL">Alabama</option>
                  <option value="WY">Wyoming</option>
                  <option value="AM">America</option>
                  <option value="CA">Canada</option>
                  <option value="RU">Russia</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Typeahead</h4>
              <p className="card-description">A simple suggestion engine</p>
              <div className="form-group row">
                <div className="col">
                  <label>Basic</label>
                  <div id="the-basics">
                    <input
                      className="typeahead"
                      type="text"
                      placeholder="States of USA"
                    />
                  </div>
                </div>
                <div className="col">
                  <label>Bloodhound</label>
                  <div id="bloodhound">
                    <input
                      className="typeahead"
                      type="text"
                      placeholder="States of USA"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default form
